// Library methods
import { useCallback, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useTranslation } from "react-i18next";

// MUI Components
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";

// Components
import AdminModeModal from "../AdminModeModal";
import SignOutModal from "../SignOutModal";
import UserMenu from "../UserMenu";
import NavbarTextButton from "../Navbar/NavbarTextButton";
import { UserIcon } from "../../../assets/icons";

const adminRoute = "/admin/clinics";

const UserMenuWrapper = ({ canReachPages }) => {
  const { t } = useTranslation();

  // routing
  const navigate = useNavigate();

  // logout function
  const { logout } = useAuth0();

  // menu state
  const [userMenu, setUserMenu] = useState(null);
  const [adminModeModal, setAdminModeModal] = useState(false);
  const [signOutModal, setSignOutModal] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);

  // menu click handler
  const userMenuClick = (event) => {
    setUserMenu(event.currentTarget);
  };

  // menu close handler
  const userMenuClose = () => {
    setUserMenu(null);
  };

  // handle admin modal confirm
  const handleAdminConfirm = useCallback(() => {
    setUserMenu(null);
    setAdminModeModal(false);
    navigate(adminRoute);
  }, [navigate, setUserMenu]);

  // handle admin click
  const handleAdminClick = useCallback(() => setAdminModeModal(true), []);

  // handle clinic settings click
  const handleClinicSettings = useCallback(
    () => navigate("/clinic-settings"),
    [navigate]
  );

  const handleLogout = useCallback(
    (event) => {
      if (event) {
        // Clear local storage
        localStorage.clear();
        sessionStorage.clear();
        logout({
          logoutParams: {
            returnTo: process.env.REACT_APP_URL,
            client_id: process.env.REACT_APP_AUTH0_CLIENT_ID,
          },
        });
      }
    },
    [logout]
  );

  // Modal handlers
  const handleSignOutClick = useCallback((event) => {
    setSignOutModal(true);
  }, []);

  const handleSignOutConfirm = useCallback(
    (event) => {
      handleLogout(event);
      setSignOutModal(false);
    },
    [handleLogout]
  );

  return (
    <>
      {/* Account icon button */}
      <Button
        data-testid="navbar-account-button"
        onClick={userMenuClick}
        sx={{
          position: "relative",
          display: { xs: "flex", sm: "none" },
          minWidth: { xs: 0, sm: 64 },
          ml: { md: 2, lg: 4 },
          color: "#E7EBF8",
          fontSize: 20,
        }}
      >
        <UserIcon aria-label={t("word_account")} />
      </Button>
      {/* Account text button */}
      <Box sx={{ display: { xs: "none", sm: "block" } }}>
        <NavbarTextButton
          dataTestId="navbar-account-button"
          title={t("word_account")}
          onClick={userMenuClick}
          customStyles={{ fontSize: 16 }}
          leftIcon={<UserIcon color="#E7EBF8" aria-label={t("word_account")} />}
        />
      </Box>

      <UserMenu
        canReachPages={canReachPages}
        userMenu={userMenu}
        userMenuClose={userMenuClose}
        handleLeftClick={handleAdminClick}
        handleCenterClick={handleClinicSettings}
        handleRightClick={handleSignOutClick}
        isAdmin={isAdmin}
        setIsAdmin={setIsAdmin}
        // setAdminModeModal={setAdminModeModal}
        // setSignOutModal={setSignOutModal}
      />
      <AdminModeModal
        open={adminModeModal}
        onClose={() => setAdminModeModal(false)}
        onCancel={() => setAdminModeModal(false)}
        onConfirm={handleAdminConfirm}
      />
      <SignOutModal
        open={signOutModal}
        onClose={() => setSignOutModal(false)}
        onCancel={() => setSignOutModal(false)}
        onConfirm={handleSignOutConfirm}
      />
    </>
  );
};

export default UserMenuWrapper;
